import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './Button';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from './Sheet';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/80 backdrop-blur-md shadow-soft py-4' : 'bg-transparent py-6'}`} data-id="element-11">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-12">
        <a href="#" className="flex items-center z-10" data-id="element-13">
          <img src="https://cdn.magicpatterns.com/uploads/59SWUdP2NiNsZvDPPVbptJ/att.XRxbh1PvlSZrmxcNX779JgQEYy5SJkZWVXYYJKDnsqg.jpg" alt="Maid In Heaven Cleaning" className="h-16 md:h-20 w-auto rounded-xl shadow-soft" data-id="element-14" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-15">
          <div className="flex gap-6" data-id="element-16">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-charcoal/80 hover:text-brand-blue transition-colors font-medium text-sm uppercase tracking-wider" data-id="element-17">
                {link.name}
              </a>)}
          </div>
          <Button className="bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full px-6 h-12 font-medium shadow-soft" data-id="element-18">
            Book a Clean
          </Button>
        </div>

        {/* Mobile Nav */}
        <div className="lg:hidden" data-id="element-19">
          <Sheet open={menuOpen} onOpenChange={setMenuOpen} data-id="element-20">
            <SheetTrigger asChild data-id="element-21">
              <Button variant="ghost" size="icon" className="text-brand-charcoal" data-id="element-22">
                <Menu className="w-6 h-6" data-id="element-23" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-screen max-w-none h-full bg-brand-white border-none p-0 flex flex-col" data-id="element-24">
              <SheetHeader className="px-6 pt-6 text-center items-center" data-id="element-25">
                <SheetTitle className="flex items-baseline justify-center gap-1.5" data-id="element-26">
                  <span className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-27">
                    Maid In
                  </span>
                  <span className="text-3xl font-script text-brand-blue" data-id="element-28">
                    Heaven
                  </span>
                </SheetTitle>
              </SheetHeader>
              <div className="flex-1 flex flex-col items-center justify-center gap-8 px-8 -mt-12" data-id="element-29">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMenuOpen(false)} className="text-2xl font-serif font-medium text-brand-charcoal hover:text-brand-blue transition-colors" data-id="element-30">
                    {link.name}
                  </a>)}
                <Button onClick={() => setMenuOpen(false)} className="bg-brand-gold hover:bg-brand-gold/90 text-white rounded-full w-full max-w-xs h-14 mt-4 text-lg shadow-soft" data-id="element-31">
                  Book a Clean
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>;
}